export default "__VITE_ASSET__0de8ffb4__"